export const staff_description =
  "Командир круизного лайнера «Северное сияние». Судьба этого человека неразрывно связана с водой. Потомственный моряк в четвертом поколении, он сделал свою первую кругосветку еще юнгой в 16 лет. Сегодня за его плечами — 28 лет безупречной службы и более 500 успешных рейсов.";
